module.exports = __webpack_public_path__ + "static/media/placeholderImg.5d4918d7.svg";